import { startTransaction } from '@sentry/browser';
import { SentryEventType, SentryLogEvent } from '@shared/sentry';

export function startHandlingSentryLogs(): void {
  window.addEventListener('message', onMessage);
}

export function removeSentryLogsHandler(): void {
  window.removeEventListener('message', onMessage);
}

function onMessage(event: MessageEvent): void {
  if (event.origin === window.location.origin && event.data.type === SentryEventType.Log) {
    const sentryLogEvent = event.data.content as SentryLogEvent;
    const transaction = startTransaction({
      name: sentryLogEvent.message,
    });
    const span = transaction.startChild({
      op: sentryLogEvent.message,
    });
    span.finish();
    transaction.finish();
  }
}
